import React from 'react';

import './styles.css';


const Component = ({ question, answer }) => (
  <div styleName="questionContainer">
    <div styleName="question">
      { question }
    </div>
    <div styleName="answer">
      { answer() }
    </div>
  </div>
);

Component.displayName = 'Question';

export default Component;



// WEBPACK FOOTER //
// ./src/components/FAQ/Question.js